/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconArrowLeft8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowLeft8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path d="M5.374 1.471 2.943 3.902l2.43 2.431-.47.472L2 3.902 4.902 1l.472.471Z" fill="currentColor" />
        </SVGContainer>
    );
});

const IconArrowLeft12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowLeft12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path d="M8.06 2.207 4.415 5.854 8.061 9.5l-.707.707L3 5.854 7.354 1.5l.707.707Z" fill="currentColor" />
        </SVGContainer>
    );
});

const IconArrowLeft16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowLeft16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path d="M10.747 2.943 5.885 7.805l4.862 4.862-.942.942L4 7.805 9.805 2l.942.943Z" fill="currentColor" />
        </SVGContainer>
    );
});

const IconArrowLeft20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowLeft20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="M13.434 3.678 7.357 9.756l6.077 6.077-1.178 1.179L5 9.756 12.256 2.5l1.178 1.178Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconArrowLeft24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowLeft24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="m16.121 4.414-7.293 7.293L16.121 19l-1.414 1.414L6 11.707 14.707 3l1.414 1.414Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconArrowLeft = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowLeft(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconArrowLeft8 {...iconProps} />;
        case '12':
            return <IconArrowLeft12 {...iconProps} />;
        case '16':
            return <IconArrowLeft16 {...iconProps} />;
        case '20':
            return <IconArrowLeft20 {...iconProps} />;
        case '24':
            return <IconArrowLeft24 {...iconProps} />;
        default:
            return <IconArrowLeft24 {...iconProps} />;
    }
});
